import './main.css';

import { useEffect, useRef, useState } from 'react';
import { IonButton, IonCard, IonCardTitle, IonCol, IonGrid, IonIcon, IonRow } from '@ionic/react';
import { checkboxOutline, eyeOff, gitBranchOutline, imagesOutline, square, squareOutline, trash } from 'ionicons/icons';
import { _ACTIVITY_ROOT, _ALIAS_SUFFIX, _NEW_LINE, _TEMPLATE_A, _cardFontSizeMax, _cardFontSizeMin, _cardSizeDelta, _cardSizeMultiplier, _cardSizeMultiplierMax, _cardWidthMax, _cardWidthMin, _debugMode, _defaultButtonColor, _dict, _emptyLabel, _libName, _pathSeparator, _photoPrefix, _possibleCardColors, _rootName, _soundPrefix, shouldIReadThis } from './constants';
import { checkSentenceRules, compareArrays, moveSublist, updict } from './foo';
import { useHistory } from 'react-router';
import { displayPic, isYoutubeUrl } from './usePhotoGallery';
import { getTTSOptions, rateLimitedPlaySound } from './useRecorder';
import { useTts } from 'tts-react';
import { useTreeStore } from './stateManagement/treeZustand';
import { useGlobalStore } from './stateManagement/globalZustand';
import { useURLStore } from './stateManagement/URLZustand';
import { useUserStore } from './stateManagement/userZustand';
import { useUIStore } from './stateManagement/UIZustand';
import { calculateCardAndFontSize, label2LabelToShow } from '../foo/cards';
import ClickAnalyzer from './ClickAnalyzer';
import CardZero from './CardZero';



interface CardProps {
  index: number;
  label: string;
  setVideoURL?: any;
  disableGoToNextNode?: boolean;
  executeOnClick?: any;
}

function Card(props: CardProps) {
  
  const { isParentMode, lang, sentence, setSentence } = useGlobalStore();
  const { nodes, setNodes, l2Image, l2Audio, l2Color, l2Visibility, freeNodes, updateCardToggle,
    path2Params, defaultParams, getImage} = useTreeStore();

  
  const { isSubscribed, userUniqueId } = useUserStore();
  const { setIRLabel, setIRLabelIndex, setIsIROpen } = useUIStore();
  const { checkIfCardIsInMultipleChoices, isLibPath, getNextNodePath, getURLTo, URLVars } = useURLStore();
  const [isCardMultipleChoice, setIsCardMultipleChoice] = useState<boolean>(false);

  const [multipleChoiceIcon, setMultipleChoiceIcon] = useState<any>(squareOutline);


  const [playAutoSound, setPlayAutoSound] = useState<boolean>(false);
  const [isCardEditable, setIsCardEditable] = useState(false);


  const newPath = getNextNodePath(props.label);

  const parentRef = useRef<HTMLDivElement>(null);

  const handleCustomClickEvent = (eventType: 'single' | 'double' | 'long' | 'context') => {
    handleCardClick()  
    if (props.executeOnClick !== undefined) {
      props.executeOnClick();
    }  
  };





  const history = useHistory();
  const capitalizeText = path2Params[URLVars.nodePath!]?.capitalizeText || defaultParams.capitalizeText;
  const [showCardColor, setShowCardColor] = useState<boolean>(checkIfCardIsInMultipleChoices(props.label) === true);
  const labelToShow = label2LabelToShow(props.label, lang, capitalizeText);


  useEffect(() => {
    setIsCardMultipleChoice(checkIfCardIsInMultipleChoices(props.label));
  }, [updateCardToggle]);


  /*function triggerBlink() {
    if(props.sentenceIonColRef === undefined || props.sentenceIonColRef.current === null) return;
    if (props.sentenceIonColRef.current) {
      props.sentenceIonColRef.current.classList.add('blink');

      props.sentenceIonColRef.current.addEventListener('animationend', () => {
        props.sentenceIonColRef.current?.classList.remove('blink');
      });
    }
  }*/

  /* [START] CODE SNIPPET FOR AUTO AUDIO IF NOT RECORDED */
  const { play } = useTts(getTTSOptions(lang, labelToShow)); // REF-A
  useEffect(() => {
    if (playAutoSound) {
      play();
      setPlayAutoSound(false);
    }
  }, [playAutoSound]);
  /* [END] CODE FOR AUTO AUDIO IF NOT RECORDED */

  const handleCardClick = () => {
    if (_debugMode) { console.log("CALLED handleCardClick. CardSoud=", l2Audio[props.label]) }
    if (isParentMode === false) {
      if (isCardMultipleChoice) {
        setShowCardColor(!showCardColor);
        setMultipleChoiceIcon(showCardColor ? checkboxOutline : squareOutline);
        return;
      }

      // Do not add to sentence if we are in saved card library or is made of special chars only
      if ((!isLibPath() && !isYoutubeUrl(l2Image[props.label])) && shouldIReadThis(labelToShow)) {

        // New sentence
        let sentenceToCheck = [...sentence, props.label];

        // Checking rules
        let newSentence = checkSentenceRules(sentenceToCheck, nodes);

        
        if (newSentence !== null) {
          if (compareArrays(sentenceToCheck, newSentence) === false) {
            //triggerBlink();
          }
          setSentence(newSentence);
        }

      }

      if (props.setVideoURL !== undefined && isYoutubeUrl(l2Image[props.label])) {
        props.setVideoURL(l2Image[props.label]);
      }


      if (!l2Audio.hasOwnProperty(props.label)) {
        setPlayAutoSound(true);
      } else{
        rateLimitedPlaySound(l2Audio[props.label]!);
      }

      if (props.disableGoToNextNode !== true && isParentMode === false && nodes[newPath] !== undefined && nodes[newPath].length > 0) {
        history.push(getURLTo().talkFromNextNodePath(props.label));
      }


    }else{
      setIRLabel(props.label);
      setIRLabelIndex(props.index);
      setIsIROpen(true);
    }
  };


  

  /*
  //POSITION-BUTTON-RELATED
  const positionButton = <IonButton onMouseDown={handleMouseDown} shape="round" color="light"><IonIcon  icon={swapHorizontal} /></IonButton>;
  */

  if (isParentMode === false && l2Visibility[props.label] === false) {
    return null;
  }

  let icons: any[] = [];

  if(isParentMode === true && l2Visibility[props.label] === false){
    icons = [...icons, eyeOff];
  }
  if(isCardMultipleChoice){
    icons = [...icons, multipleChoiceIcon];
  }
  if(nodes[newPath] !== undefined && nodes[newPath].length > 0){
    icons = [...icons, gitBranchOutline];
  }


return (
  <>
      <div ref={parentRef}>
        <ClickAnalyzer
          targetRef={parentRef}
          onCustomClickEvent={handleCustomClickEvent}
        />
        <CardZero
          label={props.label}
          image={getImage(props.label)}
          icons={icons}
          isBorderHighlighted={isCardEditable}
          backgroundColor={l2Color[props.label] || undefined}
        />
      </div>
  </>
);
}
export default Card;